const clothingConfig = {
    boys: {
      halfShirt: { rotation: [0,0,0], scale: [10,10,10],position: [0, -0.003, -0.029]  },
      sleevesLessShirt: { rotation: [-Math.PI / 2, 0, 0], scale: [7.76,7.76,7.76],position: [0, 0.038, -0.067]  },
      halfPan: { rotation: [-Math.PI / 2, 0, 0], scale: [0.08,0.08,0.08],position: [-0.031, -0.008, 0]  },
      fullPan: { rotation: [-Math.PI / 2, 0, 0], scale: [0.08,0.08,0.08],position: [0, 0, -0.251]  },
    //   shorts: { rotation: [Math.PI / 2, 0, 0], scale: [-1.863, -1.61, -1.726],position: [-0.031, -0.008, 0]  },
    },
    girls: {
    //   halfShirt: { rotation: [-Math.PI / 2, 0, 0], scale: [0.012],position: [0, 0, 0]  },
    halfShirt: { rotation: [-Math.PI/2, 0, 0], scale: [0.08,0.08,0.08],position: [0, 0, 0]  },
      fullShirt: { rotation: [-Math.PI / 2, 0, 0], scale: [1.3,1.3,1.3],position: [0,0,0]  },
      sleevesLessShirt: { rotation: [0, 0, 0], scale: [7.76,7.76,7.76],position: [0, 0, 0]  },
    //   shorts: { rotation: [0, 0, 0], scale: [0, 0, 0],position: [0, 0, 0]  },
    },
  };
  
  export default clothingConfig;
  